import React, { useState, useEffect } from "react";
import axios from "axios";

export default function MasterOtp() {
  const [masterOtp, setMasterOtp] = useState("");
  const [newOtp, setNewOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);

  // Fetch current OTP
  useEffect(() => {
    const fetchOtp = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_LIVE_URL}/adminPanel/masterOtp`
        );
        if (response.data.status) {
          setMasterOtp(response.data.data.masterOtp);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchOtp();
  }, []);

  // Update OTP
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!newOtp) return alert("Please enter new Master OTP");
    if (newOtp.length !== 6) return alert("Master OTP must be 6 digits");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_LIVE_URL}/adminPanel/masterOtp`,
        { masterOtp: newOtp }
      );

      if (response.data.status) {
        setMasterOtp(newOtp);
        setNewOtp("");
        alert("Master OTP updated successfully!");
      } else {
        alert(response.data.msg);
      }
    } catch (err) {
      console.log(err);
      alert("Server error while updating OTP");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Master OTP</h2>
        <p style={styles.subtitle}>View or update your Master OTP below.</p>

        <label style={styles.label}>Current Master OTP:</label>

        <div style={styles.inputWrapper}>
          <input
            type={showOtp ? "text" : "password"}
            value={masterOtp}
            readOnly
            style={styles.readonlyInput}
          /> 

          <span
            style={styles.eyeIcon}
            onClick={() => setShowOtp(!showOtp)}
          >
            <span style={styles.eyeIcon} onClick={() => setShowOtp(!showOtp)}>
              {showOtp ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 5C5.5 5 1 12 1 12C1 12 5.5 19 12 19C18.5 19 23 12 23 12C23 12 18.5 5 12 5Z"
                    stroke="#555"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="#555"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M1 1L23 23"
                    stroke="#555"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M12 5C5.5 5 1 12 1 12C1 12 5.5 19 12 19C18.5 19 23 12 23 12C23 12 18.5 5 12 5Z"
                    stroke="#555"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.5 9.5C9 10.2 8.8 11 9 11.8C9.2 12.6 9.7 13.3 10.4 13.8C11.1 14.3 12 14.4 12.8 14.1C13.6 13.9 14.3 13.4 14.8 12.7"
                    stroke="#555"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </span>

          </span>
        </div>

        <form onSubmit={handleUpdate}>
          <label style={styles.label}>Enter New Master OTP:</label>
          <input
            type="text"
            maxLength="6"
            placeholder="Enter new Master OTP"
            value={newOtp}
            onChange={(e) => setNewOtp(e.target.value)}
            style={styles.input}
          />

          <button type="submit" style={styles.button}>
            Update OTP
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    paddingTop: "80px",
    background: "#f7f8fc",
    fontFamily: "Inter, Arial",
  },

  card: {
    width: "450px",
    background: "#fff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
  },

  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#222",
    marginBottom: "5px",
  },

  subtitle: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "25px",
  },

  label: {
    display: "block",
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "6px",
    marginTop: "15px",
  },

  inputWrapper: {
    position: "relative",
    width: "100%",
  },

  readonlyInput: {
    width: "100%",
    padding: "12px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #d0d7e0",
    background: "#eef3ff",
    color: "#000",
    marginBottom: "15px",
  },

  eyeIcon: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    fontSize: "20px",
    userSelect: "none",
  },

  input: {
    width: "100%",
    padding: "12px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #c6cbe0",
    background: "#f4f6ff",
    outline: "none",
  },

  button: {
    width: "100%",
    marginTop: "25px",
    padding: "14px",
    fontSize: "16px",
    fontWeight: "600",
    borderRadius: "12px",
    border: "none",
    cursor: "pointer",
    color: "#fff",
    background: "#9b4dff",
    boxShadow: "0px 8px 20px rgba(155, 77, 255, 0.4)",
    transition: "0.3s",
  },
};
